import { parse as URIParse, serialize as URISerialize } from 'uri-js';
import { isLocal, getUrlParams } from '@utils/tools';

// 域名白名单
const HOST_WHITE_LIST = ['meituan.com', 'sankuai.com'];
// 本地开发环境加上localhost以及本地ip
if (isLocal()) {
  HOST_WHITE_LIST.unshift('localhost');
  // HOST_WHITE_LIST.unshift('11.39.111.60');
}

// host是否在域名白名单里
function isInWhiteListOfHostFn(url = '') {
  try {
    const urlObj = URIParse(url);
    // 没有host，url是相对地址
    if (!urlObj.host && urlObj.path?.startsWith('/')) return true;
    const newUrl = HOST_WHITE_LIST.find((item) => urlObj.host?.includes(item));
    if (!newUrl) {
      console.error('host不在白名单');
    }
    return Boolean(newUrl);
  } catch (err) {
    console.error(err);
  }
  return false;
}

interface IAddQueryOpts {
  isCheckUrlHost?: boolean;
}
const DEFAULT_COPY_QUERY_LIST = ['token', 'staffSsoId'];
// 将当前url的一些参数设置到即将跳转的url上
function appendQuery2TargetUrlFromCurrentUrl(url = '', currentUrl?: string, opts?: IAddQueryOpts) {
  const { isCheckUrlHost = true } = opts || {};
  if (!url) {
    url = '';
  }
  if (!currentUrl) {
    currentUrl = window.location.href;
  }
  try {
    // 检查跳转的url host是否在白名单
    if (isCheckUrlHost && url) {
      const isWhiteHost = isInWhiteListOfHostFn(url);
      if (!isWhiteHost) return '';
    }
    const urlObj = URIParse(url);
    const currentUrlQueryObj = getUrlParams(currentUrl);
    const addList = [];
    // 获取需要追加的query
    DEFAULT_COPY_QUERY_LIST.forEach((item) => {
      if (currentUrlQueryObj[item]) {
        // @ts-ignore
        addList.push(`${item}=${currentUrlQueryObj[item]}`);
      }
    });
    // 追加query到目标url
    if (addList.length > 0) {
      urlObj.query = `${urlObj.query ? `${urlObj.query}&` : ''}${addList.join('&')}`;
    }
    return URISerialize(urlObj);
  } catch (err) {
    return '';
  }
}
export { isInWhiteListOfHostFn, appendQuery2TargetUrlFromCurrentUrl };
